import { API_BASE_URL } from "../../config";
import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import useFetchUserSeller from "../Utils/useFetchUserSeller";
import { useFetchData } from "../Utils/useFetchData";
import { useNavigate } from "react-router-dom";

const DeliverySchedule = () => {
    const navigate = useNavigate();
    const handleLogout = useCallback(() => {
        localStorage.removeItem("user");
        navigate("/login");
    }, [navigate]);

    const userIds = useFetchUserSeller(handleLogout);
    const { fetchData } = useFetchData(handleLogout);
    const [selectedSeller, setSelectedSeller] = useState(null);
    const [scheduleList, setScheduleList] = useState([]);
    const [activeTime, setActiveTime] = useState("08:00:00");
    const [timeShift, setTimeShift] = useState(9.5);
    const [enabled, setEnabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const baseApi = `${API_BASE_URL}/seller/api/v1/seller-active-times`;

    const loadScheduleList = useCallback(async () => {
        setLoading(true);
        const data = await fetchData(baseApi);
        if (data) {
            setScheduleList(data);
        }
        setLoading(false);
    }, [fetchData]);

    useEffect(() => {
        loadScheduleList();
    }, [loadScheduleList]);

    const handleCreateOrUpdate = async () => {
        if (!selectedSeller) {
            alert("Please select a seller");
            return;
        }
        const payload = {
            sellerId: selectedSeller.value,
            activeTime,
            timeShift: parseFloat(timeShift),
            enabled
        };
        if (editingId) {
            payload.id = editingId;
        }

        const result = await fetchData(baseApi, "POST", payload);
        if (result) {
            loadScheduleList();
            resetForm();
            alert(editingId ? "Updated successfully" : "Created successfully");
        }
    };

    const handleEdit = (item) => {
        setEditingId(item.id);
        const seller = userIds.find(u => u.uid === item.sellerId);
        setSelectedSeller(seller ? { value: seller.uid, label: seller.nameuser } : { value: item.sellerId, label: item.sellerId });
        setActiveTime(item.activeTime);
        setTimeShift(item.timeShift);
        setEnabled(item.enabled);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this schedule?")) {
            await fetchData(`${baseApi}/${id}`, "DELETE");
            loadScheduleList();
        }
    };

    const resetForm = () => {
        setEditingId(null);
        setSelectedSeller(null);
        setActiveTime("08:00:00");
        setTimeShift(9.5);
        setEnabled(true);
    };

    const sellerOptions = (userIds || []).map(user => ({
        value: user.uid,
        label: user.nameuser,
        username: user.username,
    }));

    return (
        <div className="btc-container">
            <h1 className="btc-heading">Delivery Schedule (Seller Active Times)</h1>

            <div className="btc-table-container" style={{ marginBottom: "20px", padding: "20px" }}>
                <h3>{editingId ? "Update Schedule" : "Create New Schedule"}</h3>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "10px" }}>
                    <div>
                        <label>Seller:</label>
                        <Select
                            options={sellerOptions}
                            value={selectedSeller}
                            onChange={setSelectedSeller}
                            placeholder="Select Seller..."
                            isClearable
                        />
                    </div>
                    <div>
                        <label>Active Time (HH:mm:ss):</label>
                        <input
                            type="text"
                            value={activeTime}
                            onChange={(e) => setActiveTime(e.target.value)}
                            style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                        />
                    </div>
                    <div>
                        <label>Time Shift (hours):</label>
                        <input
                            type="number"
                            step="0.1"
                            value={timeShift}
                            onChange={(e) => setTimeShift(e.target.value)}
                            style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <input
                            type="checkbox"
                            checked={enabled}
                            onChange={(e) => setEnabled(e.target.checked)}
                            id="enabled-checkbox"
                        />
                        <label htmlFor="enabled-checkbox">Enabled</label>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                    <button className="btc-btn" onClick={handleCreateOrUpdate}>
                        {editingId ? "Update" : "Create"}
                    </button>
                    {editingId && (
                        <button className="btc-btn" onClick={resetForm} style={{ backgroundColor: "#6c757d" }}>
                            Cancel
                        </button>
                    )}
                </div>
            </div>

            <div className="btc-table-container">
                <h3>Active Time Schedules</h3>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <table className="btc-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Seller Name</th>
                                <th>Active Time</th>
                                <th>Time Shift</th>
                                <th>Enabled</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scheduleList.map((item) => {
                                const seller = userIds.find(u => u.uid === item.sellerId);
                                return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{seller ? seller.nameuser : item.sellerId}</td>
                                        <td>{item.activeTime}</td>
                                        <td>{item.timeShift}</td>
                                        <td>{item.enabled ? "Yes" : "No"}</td>
                                        <td>
                                            <button 
                                                className="btc-btn btn-sm" 
                                                onClick={() => handleEdit(item)}
                                                style={{ marginRight: "5px", backgroundColor: "#ffc107", color: "#000" }}
                                            >
                                                Edit
                                            </button>
                                            <button 
                                                className="btc-btn btn-sm" 
                                                onClick={() => handleDelete(item.id)}
                                                style={{ backgroundColor: "#dc3545" }}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default DeliverySchedule;
